export default "__VITE_ASSET__1c329ef2__"